(function () {
  'use strict';
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ss-faqs-list]').forEach(function (list) {
      var search = document.querySelector('[data-ss-faqs-search]');
      var empty = list.querySelector('[data-ss-faqs-empty]');
      var items = list.querySelectorAll('.ss-faqs-page__item');

      list.querySelectorAll('.ss-faqs-page__item').forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          list.querySelectorAll('.ss-faqs-page__item').forEach(function (other) {
            if (other !== item) other.open = false;
          });
        });
      });

      if (!search) return;
      search.addEventListener('input', function () {
        var q = search.value.toLowerCase().trim();
        var visible = 0;
        items.forEach(function (item) {
          var text = item.textContent.toLowerCase();
          var show = !q || text.indexOf(q) >= 0;
          item.hidden = !show;
          if (show) visible++;
        });
        if (empty) empty.hidden = visible > 0;
      });
    });
  });
})();
